/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeResponseSchema } from './availabilityRangeResponseSchema';

export const pageResponseAvailabilityRangeResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(availabilityRangeResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
